import { useRef, useState } from 'react';

import { Box, Typography } from '@mui/material';
import { MovieRounded } from '@mui/icons-material';

import { Center } from 'components/Common/Centered';
import OutlinedBox from 'components/Common/OutlinedBox';

import { CONTROL_CENTER_OUTPUT_PATH_ID } from 'constants/CommonConstants';
import { UserTourClassSelector } from 'constants/UserTourConstants';

import HlsVideoPlayer from '../../Common/HlsVideoPlayer';

export const HLSOutputNode = ({
  outputUrl,
  isActive,
  eventId,
  refreshPreview = false,
  resetRefreshState,
}: {
  outputUrl: string;
  isActive: boolean;
  eventId?: string;
  refreshPreview?: boolean;
  resetRefreshState?: () => void;
}): JSX.Element => {
  const [hasLoaded, setHasLoaded] = useState(false);
  const playerRef = useRef<HTMLVideoElement>(null);

  return (
    <OutlinedBox
      p={0.5}
      borderRadius={1}
      width="100%"
      height="100%"
      id={CONTROL_CENTER_OUTPUT_PATH_ID}
      active={isActive}
      className={UserTourClassSelector.SHOW_OUTPUTS}
    >
      <Box
        borderRadius="5px"
        width="100%"
        height="100%"
        position="relative"
        sx={{ cursor: outputUrl ? 'pointer' : 'normal' }}
      >
        <HlsVideoPlayer
          customStyles={{ borderRadius: '5px' }}
          src={outputUrl}
          videoRef={playerRef}
          autoPlay
          controls
          onLoadedMetadata={() => {
            setHasLoaded(true);
          }}
          eventId={eventId}
          refreshPreview={refreshPreview}
          resetRefreshState={resetRefreshState}
        />
        {!hasLoaded && (
          <Center
            width="100%"
            height="100%"
            borderRadius={1}
            bgcolor="grey.100"
            color="grey.600"
            position="absolute"
            top="0"
            textAlign="center"
          >
            <MovieRounded fontSize="large" sx={{ mb: 1 }} />
            <Typography variant="body2">Loading...</Typography>
          </Center>
        )}
      </Box>
    </OutlinedBox>
  );
};
